import createSvgIcon from '../../Utils/CreateSvgIcon';

export const AccessTiers = createSvgIcon(
  <path
    d="M11 23C10.7167 23 10.4793 22.904 10.288 22.712C10.0967 22.52 10.0007 22.2827 10 22C9.99934 21.7173 10.0953 21.48 10.288 21.288C10.4807 21.096 10.718 21 11 21H16V16C16 15.7167 16.096 15.4793 16.288 15.288C16.48 15.0967 16.7173 15.0007 17 15H22V10C22 9.71667 22.096 9.47933 22.288 9.288C22.48 9.09667 22.7173 9.00067 23 9H29C29.2833 9 29.521 9.096 29.713 9.288C29.905 9.48 30.0007 9.71733 30 10C29.9993 10.2827 29.9033 10.5203 29.712 10.713C29.5207 10.9057 29.2833 11.0013 29 11H24V16C24 16.2833 23.904 16.521 23.712 16.713C23.52 16.905 23.2827 17.0007 23 17H18V22C18 22.2833 17.904 22.521 17.712 22.713C17.52 22.905 17.2827 23.0007 17 23H11Z"
    transform="translate(-8 -4)"
    stroke="currentColor"
    strokeWidth="0.5"
  />,
  'AccessTiers',
);
